import {
  AddSelectedTranslationFileAction,
  AddSelectedTranslationFilePayload,
  AddTranslationTaskAction,
  AddTranslationTaskPayload,
  ClearCurrentTranslationTaskSelectedFilesAction,
  ClearCurrentTranslationTaskSelectedLanguagesAction,
  ClearTemporaryTranslationTaskAction,
  DeleteTranslationTaskAction,
  DeleteTranslationTaskPayload,
  EditTranslationTaskNameAction,
  EditTranslationTaskPayload,
  FetchAllLanguageDataAction,
  FetchAllLanguageDataSuccessAction,
  FetchAllLanguageDataSuccessPayload,
  GetDetailTranslationTaskAction,
  GetDetailTranslationTaskPayload,
  GetLatestTranslationTaskAction,
  GetTranslationTasksAction,
  GetTranslationTasksPayload,
  LoadTemporaryTranslationTaskDataAction,
  RemoveSelectedFilePayload,
  RemoveSelectedTranslationFileAction,
  RequestDownloadAllTranslatedFilesAction,
  ResetTranslationDataAction,
  SetInputLanguageAction,
  SetInputLanguagePayload,
  SetOuputLanguageAction,
  SetOutputLanguagePayload,
  UpdateCurrentTranslatedFilesAction,
  UpdateCurrentTranslatedFilesPayload,
  UpdateCurrentTranslationTaskAction,
  UpdateCurrentTranslationTaskPayload,
  UpdateDownloadTranslatedFilesStatusAction,
  UpdateDownloadTranslatedFilesStatusPayload,
  UpdateFileStatusPayload,
  UpdateInitialSelectedTranslationFilesAction,
  UpdateLimitStatusPayload,
  UpdateLimitStatusTranslationTaskAction,
  UpdateProcessTranslationTaskIdAction,
  UpdateProcessTranslationTaskIdPayload,
  UpdateSelectedFilePayload,
  UpdateSelectedTranslationFileAction,
  UpdateTemporaryTranslationTaskIdAction,
  UpdateTemporaryTranslationTaskIdPayload,
  UpdateTranslatedFileAction,
  UpdateTranslatedFilePayload,
  UpdateTranslatedFileStatusAction,
  UpdateTranslatedFileStatusPayload,
  UpdateTranslationFileStatusAction,
  UpdateTranslationStatusAction,
  UpdateTranslationStatusPayload,
  UpdateTranslationTasksAction,
  UpdateTranslationTasksPayload,
} from 'types/actions/translation';

import { translationTaskConstant } from '../actionTypes';

export const getTranslationTasks = (
  payload?: GetTranslationTasksPayload
): GetTranslationTasksAction => ({
  type: translationTaskConstant.GET_TRANSLATION_TASKS,
  payload,
});

export const updateTranslationTasks = (
  payload: UpdateTranslationTasksPayload
): UpdateTranslationTasksAction => ({
  type: translationTaskConstant.UPDATE_TRANSLATION_TASKS,
  payload,
});

export const editTranslationTaskName = (
  payload: EditTranslationTaskPayload
): EditTranslationTaskNameAction => ({
  type: translationTaskConstant.EDIT_TRANSLATION_TASK_NAME,
  payload,
});

export const deleteTranslationTask = (
  payload: DeleteTranslationTaskPayload
): DeleteTranslationTaskAction => ({
  type: translationTaskConstant.DELETE_TRANSLATION_TASK,
  payload,
});

export const updateTranslationStatus = (
  payload: UpdateTranslationStatusPayload
): UpdateTranslationStatusAction => ({
  type: translationTaskConstant.UPDATE_STATUS_TRANSLATION_TASK,
  payload,
});

export const updateCurrentTranslatedFiles = (
  payload: UpdateCurrentTranslatedFilesPayload
): UpdateCurrentTranslatedFilesAction => ({
  type: translationTaskConstant.UPDATE_CURRENT_TRANSLATED_FILES,
  payload,
});

export const clearCurrentTaskSelectedFiles =
  (): ClearCurrentTranslationTaskSelectedFilesAction => ({
    type: translationTaskConstant.CLEAR_CURRENT_TASK_SELECTED_FILES_TRANSLATION,
  });

export const clearCurrentTaskSelectedLanguages =
  (): ClearCurrentTranslationTaskSelectedLanguagesAction => ({
    type: translationTaskConstant.CLEAR_CURRENT_TASK_SELECTED_LANGUAGES_TRANSLATION,
  });

export const clearTemporaryTask = (): ClearTemporaryTranslationTaskAction => ({
  type: translationTaskConstant.CLEAR_TEMPORARY_TRANSLATION_TASK,
});

export const loadTemporaryTaskData = (): LoadTemporaryTranslationTaskDataAction => ({
  type: translationTaskConstant.LOAD_TEMPORARY_TRANSLATION_TASK_DATA,
});

export const updateCurrentTranslationTask = (
  payload: UpdateCurrentTranslationTaskPayload
): UpdateCurrentTranslationTaskAction => ({
  type: translationTaskConstant.UPDATE_CURRENT_TRANSLATION_TASK,
  payload,
});

export const updateProcessTaskId = (
  payload: UpdateProcessTranslationTaskIdPayload
): UpdateProcessTranslationTaskIdAction => ({
  type: translationTaskConstant.UPDATE_PROCESS_TRANSLATION_TASK_ID,
  payload,
});

export const updateTemporaryTaskId = (
  payload: UpdateTemporaryTranslationTaskIdPayload
): UpdateTemporaryTranslationTaskIdAction => ({
  type: translationTaskConstant.UPDATE_TEMPORARY_TRANSLATION_TASK_ID,
  payload,
});

export const getLatestTranslationTask = (): GetLatestTranslationTaskAction => ({
  type: translationTaskConstant.GET_LATEST_TRANSLATION_TASK,
});

export const getDetailTranslationTask = (
  payload: GetDetailTranslationTaskPayload
): GetDetailTranslationTaskAction => ({
  type: translationTaskConstant.GET_DETAIL_TRANSLATION_TASK,
  payload,
});

export const requestTranslation = () => ({
  type: translationTaskConstant.REQUEST_TRANSLATION,
});

export const addTranslationTask = (
  payload: AddTranslationTaskPayload
): AddTranslationTaskAction => ({
  type: translationTaskConstant.ADD_TRANSLATION_TASK,
  payload,
});

export const updateLimitStatus = (
  payload: UpdateLimitStatusPayload
): UpdateLimitStatusTranslationTaskAction => ({
  type: translationTaskConstant.UPDATE_LIMIT_STATUS_TRANSLATION_TASK,
  payload,
});

export const addSelectedFile = (
  payload: AddSelectedTranslationFilePayload
): AddSelectedTranslationFileAction => ({
  type: translationTaskConstant.ADD_SELECTED_TRANSLATION_FILE,
  payload,
});

export const updateSelectedFile = (
  payload: UpdateSelectedFilePayload
): UpdateSelectedTranslationFileAction => ({
  type: translationTaskConstant.UPDATE_SELECTED_TRANSLATION_FILE,
  payload,
});

export const updateTranslatedFile = (
  payload: UpdateTranslatedFilePayload
): UpdateTranslatedFileAction => ({
  type: translationTaskConstant.UPDATE_TRANSLATED_FILE,
  payload,
});

export const removeSelectedFile = (
  payload: RemoveSelectedFilePayload
): RemoveSelectedTranslationFileAction => ({
  type: translationTaskConstant.REMOVE_SELECTED_TRANSLATION_FILE,
  payload,
});

export const updateFileStatus = (
  payload: UpdateFileStatusPayload
): UpdateTranslationFileStatusAction => ({
  type: translationTaskConstant.UPDATE_TRANSLATION_FILE_STATUS,
  payload,
});

export const updateTranslatedFileStatus = (
  payload: UpdateTranslatedFileStatusPayload
): UpdateTranslatedFileStatusAction => ({
  type: translationTaskConstant.UPDATE_TRANSLATED_FILE_STATUS,
  payload,
});

export const updateInitialSelectedFiles = (): UpdateInitialSelectedTranslationFilesAction => ({
  type: translationTaskConstant.UPDATE_INITIAL_SELECTED_TRANSLATION_FILES,
});

export const resetData = (): ResetTranslationDataAction => ({
  type: translationTaskConstant.RESET_TRANSLATION_DATA,
});

export const fetchAllLanguageData = (): FetchAllLanguageDataAction => {
  return {
    type: translationTaskConstant.FETCH_ALL_LANGUAGE_DATA,
  };
};

export const fetchAllLanguageDataSuccess = (
  payload: FetchAllLanguageDataSuccessPayload
): FetchAllLanguageDataSuccessAction => ({
  type: translationTaskConstant.FETCH_ALL_LANGUAGE_DATA_SUCCESS,
  payload,
});

export const setInputLanguage = (payload: SetInputLanguagePayload): SetInputLanguageAction => ({
  type: translationTaskConstant.SET_INPUT_LANGUAGE,
  payload,
});

export const setOutputLanguage = (payload: SetOutputLanguagePayload): SetOuputLanguageAction => ({
  type: translationTaskConstant.SET_OUTPUT_LANGUAGE,
  payload,
});

export const updateDownloadTranslatedFilesStatus = (
  payload: UpdateDownloadTranslatedFilesStatusPayload
): UpdateDownloadTranslatedFilesStatusAction => ({
  type: translationTaskConstant.UPDATE_DOWNLOAD_TRANSLATED_FILE_STATUS,
  payload,
});

export const requestDownloadAllTranslatedFiles = (): RequestDownloadAllTranslatedFilesAction => ({
  type: translationTaskConstant.REQUEST_DOWNLOAD_ALL_TRANSLATED_FILES,
});
